import React from "react";
import { BiLastPage, BiFirstPage } from "react-icons/bi";
import { MdNavigateNext, MdNavigateBefore } from "react-icons/md";

// Maximum number of pages to show in the paginator (min is 3)
const PAGINGATION_SIZE = 4;

const Pagination = ({ page, setPage, last = 1 }) => {
  const pages = [...Array(last).keys()].map((i) => i + 1);

  return (
    <div className="flex flex-row items-center justify-center gap-1">
      <button className="transparent-button" onClick={() => setPage(1)} disabled={page === 1}>
        <BiFirstPage />
      </button>
      <button className="mr-4 transparent-button" onClick={() => (page - 1 < 1 ? setPage(1) : setPage(page - 1))} disabled={page === 1}>
        <MdNavigateBefore className="mr-1" />
      </button>
      <div className="w-72 flex items-center justify-center">
        {last > PAGINGATION_SIZE + 1 ? (
          page < PAGINGATION_SIZE ? (
            <>
              {pages.slice(0, PAGINGATION_SIZE).map((p) => (
                <button key={p} className={`transparent-button ${p === page ? "bg-primary text-white" : ""}`} onClick={() => setPage(p)}>
                  {p}
                </button>
              ))}
              <button className="transparent-button">...</button>
              <button className="transparent-button" onClick={() => setPage(last)}>
                {last}
              </button>
            </>
          ) : page > last - (PAGINGATION_SIZE - 1) ? (
            <>
              <button className="transparent-button" onClick={() => setPage(1)}>
                1
              </button>
              <button className="transparent-button">...</button>
              {pages.slice(last - PAGINGATION_SIZE, last).map((p) => (
                <button key={p} className={`transparent-button ${p === page ? "bg-primary text-white" : ""}`} onClick={() => setPage(p)}>
                  {p}
                </button>
              ))}
            </>
          ) : (
            <>
              <button className="transparent-button" onClick={() => setPage(1)}>
                1
              </button>
              <button className="transparent-button">...</button>
              {pages.slice(page - PAGINGATION_SIZE / 2, page + PAGINGATION_SIZE / 2 - 1).map((p) => (
                <button key={p} className={`transparent-button ${p === page ? "bg-primary text-white" : ""}`} onClick={() => setPage(p)}>
                  {p}
                </button>
              ))}
              <button className="transparent-button" disabled={true}>
                ...
              </button>
              <button className="transparent-button" onClick={() => setPage(last)}>
                {last}
              </button>
            </>
          )
        ) : (
          pages.map((p) => (
            <button key={p} className={`transparent-button ${p === page ? "bg-primary text-white" : ""}`} onClick={() => setPage(p)}>
              {p}
            </button>
          ))
        )}
      </div>
      <button className="ml-4 transparent-button" onClick={() => (page + 1 > last ? setPage(last) : setPage(page + 1))} disabled={page === last}>
        <MdNavigateNext className="" />
      </button>
      <button className="transparent-button" onClick={() => setPage(last)} disabled={page === last}>
        <BiLastPage />
      </button>
    </div>
  );
};

export default Pagination;
